export default {
  auth: {
    logged_in: "환영, ",
    logout: "로그 아웃",
    logged_out: "로그아웃 성공!",
    invalid: "잘못된 자격 증명. 다시 로그인하십시오."
  }
};
